import { Button } from "frontend-components";
import React, { type ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

interface CsvButtonProps {
    onCsvImported: (emails: string[]) => void;
}

export function CsvButton({ onCsvImported }: CsvButtonProps) {
    const { t } = useTranslation();
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        try {
            const text = await file.text();

            // Extract emails from CSV text
            const emails =
                text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi)?.map((e) => e.trim()) || [];

            if (emails.length > 0) {
                onCsvImported(emails);
            }
        } catch (err) {
            console.error("Error reading CSV:", err);
        } finally {
            // reset file input so same file can be selected again if needed
            e.target.value = "";
        }
    };

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept=".csv,text/csv"
                className="hidden"
                onChange={handleFileChange}
            />
            <Button
                type="button"
                variant="outline"
                className="w-fit rounded-sm border-b-2 border-primary/50 text-primary/50 hover:bg-secondary hover:text-primary/50"
                onClick={handleClick}
            >
                {t("participantField.importCsv")}
            </Button>
        </>
    );
}
